import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { GenericErrorHandlingService } from './generic-error-handling.service';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../grid/biz-grid.directive';
import { DxoSelectionModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { JsonPipe } from '@angular/common';

@Component({
    templateUrl: './generic-error-handling.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoSelectionModule, DxiColumnModule, DxTemplateModule, JsonPipe]
})

export class GenericErrorHandlingComponent implements OnInit {

    constructor(private genericErrorHandlingService: GenericErrorHandlingService) { }

    genericErrors: any[] = [];
    httpErrors: any[] = [];
    allErrors: any[] = [];

    ngOnInit(): void {
        this.genericErrorHandlingService.newErrorObserver.subscribe(this.reload);
        this.reload();
    }

    reload() {
        this.genericErrors = this.genericErrorHandlingService.getGenericErrors();
        this.httpErrors = this.genericErrorHandlingService.getHttpErrors();
        this.allErrors = this.genericErrorHandlingService.getAllErrors();
    }
}
